import {CookieManager} from "../CookieManager";
import {COOKIE_NAMES_PRIVACY_POLICY, COOKIE_MODE} from "../cookies-privacy/Cookies.config";
import Vue from "vue";

class CookiesPrivacyPolicyHandler {

    constructor() {
        this.cookiesPopupInstance = null;

        switch (COOKIE_MODE) {
            case 'simple':
                if (CookieManager.getCookie(COOKIE_NAMES_PRIVACY_POLICY) !== 'T' && CookieManager.getCookie(COOKIE_NAMES_PRIVACY_POLICY) !== 'N') {
                    import("../../vue/containers/CookiesInfoContainer")
                        .then(module => {
                            const container = document.createElement('div');
                            document.body.appendChild(container);

                            this.cookiesPopupInstance = new Vue(module.default);
                            this.cookiesPopupInstance.$mount(container);
                        })
                    ;
                }
                break;
            case 'extended':
                import("../../vue/containers/CookiesPopupContainer")
                    .then(module => {
                        const container = document.createElement('div');
                        document.body.appendChild(container);

                        this.cookiesPopupInstance = new Vue(module.default);
                        this.cookiesPopupInstance.$mount(container);
                    })
                ;
                break;
            case 'small':
                import("../../vue/containers/CookiesSmallContainer")
                    .then(module => {
                        const container = document.createElement('div');
                        document.body.appendChild(container);

                        this.cookiesPopupInstance = new Vue(module.default);
                        this.cookiesPopupInstance.$mount(container);
                    })
                ;
                break;
        }
    }
}

export function cookiesPrivacyPolicy() {
    new CookiesPrivacyPolicyHandler();
}
